import React from "react";
import { Layout } from "../components/Layout";
import { LotusMark } from "../components/Logo";
import { siteConfig } from "../data/siteConfig";

const sections = [
  {
    title: "Acceptance of terms",
    body: "By booking or attending a class with Yogarambh Wellness, you agree to these terms. Please read them carefully before participating.",
  },
  {
    title: "Health & safety",
    body: "Yoga involves physical movement. Please consult your doctor before starting, especially if you are pregnant, recovering from injury, or managing a medical condition. Practise within your own limits and inform your instructor of any concerns. You participate at your own risk.",
  },
  {
    title: "Bookings & payments",
    body: "Class fees, packages and schedules are as described on our pricing page and may be updated from time to time. Bookings are confirmed once payment is received, unless otherwise agreed.",
  },
  {
    title: "Cancellations & rescheduling",
    body: "Please give reasonable notice if you need to cancel or reschedule a session so the slot can be offered to someone else. Specific cancellation terms may apply to private sessions and packages.",
  },
  {
    title: "Conduct",
    body: "We aim to keep a calm, respectful and safe environment for everyone. We reserve the right to decline service to anyone whose conduct disrupts the practice or wellbeing of others.",
  },
  {
    title: "Changes to these terms",
    body: "We may update these terms occasionally. Continued participation after changes means you accept the updated terms.",
  },
];

export const TermsPage = () => {
  return (
    <Layout>
      <section className="pt-28 md:pt-32 pb-12">
        <div className="container mx-auto px-6 max-w-3xl text-center">
          <LotusMark className="w-10 h-10 mx-auto mb-5" />
          <h1 className="font-heading text-4xl md:text-5xl font-semibold text-charcoal mb-3">
            Terms of Service
          </h1>
          <p className="text-charcoal/60">
            The terms for practising with {siteConfig.name}.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container mx-auto px-6 max-w-3xl space-y-6">
          {sections.map((s) => (
            <div
              key={s.title}
              className="bg-white rounded-2xl p-7 border border-accent/15 shadow-soft"
            >
              <h2 className="font-heading text-2xl text-charcoal mb-2">
                {s.title}
              </h2>
              <p className="text-charcoal/75 leading-relaxed">{s.body}</p>
            </div>
          ))}
          <p className="text-sm text-charcoal/60 pt-2">
            Questions? Email us at{" "}
            <a
              href={`mailto:${siteConfig.email}`}
              className="text-primary font-medium"
            >
              {siteConfig.email}
            </a>
            .
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default TermsPage;
